<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 48 48"
    version="1.1"
    viewBox="0 0 48 48"
    xml:space="preserve"
  >
    <path
      clip-rule="evenodd"
      d="M35,22H13C7.477,22,3,17.523,3,12S7.477,2,13,2h22c5.522,0,10,4.477,10,10  S40.522,22,35,22z M35,4H13c-4.418,0-8,3.582-8,8s3.582,8,8,8h22c4.418,0,8-3.582,8-8S39.418,4,35,4z M13,18c-3.313,0-6-2.686-6-6  c0-3.313,2.687-6,6-6s6,2.687,6,6C19,15.314,16.313,18,13,18z M13,8c-2.209,0-4,1.791-4,4c0,2.209,1.791,4,4,4s4-1.791,4-4  C17,9.791,15.209,8,13,8z M13,26h22c5.522,0,10,4.478,10,10s-4.478,10-10,10H13C7.477,46,3,41.522,3,36S7.477,26,13,26z M13,44h22  c4.418,0,8-3.582,8-8s-3.582-8-8-8H13c-4.418,0-8,3.582-8,8S8.582,44,13,44z M35,30c3.313,0,6,2.687,6,6s-2.687,6-6,6s-6-2.687-6-6  S31.687,30,35,30z M35,40c2.209,0,4-1.791,4-4s-1.791-4-4-4s-4,1.791-4,4S32.791,40,35,40z"
      fill-rule="evenodd"
    />
  </svg>
</template>
